// extracted by mini-css-extract-plugin
export var backdropBlur = "_jh-0";
export var contentCard = "_jh-5";
export var frame = "_jh-2";
export var image = "_jh-4";
export var imagePane = "_jh-3";
export var modal = "_jh-1";